import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import {
  allAccountCategories,
  allAccountSubCategories,
} from "../../../../data/Axios/queries";
import {
  getAccountSubCategoriesColumns,
  AccountSubCategoriesColumns,
} from "../../../../data/DynamicTable/AccountsColumns";
import AccountCategoryForm from "./form";
import { graphqlQuery } from "../../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

const actions = {
  entity: "Account Subcategory",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
};

function AccountSubcategoriesTable() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const data = await graphqlQuery(allAccountCategories, base_url);
        if (data) {
          setCategories(data);
        }
      } catch (error) {
        console.error("Error fetching account categories:", error);
      }
    }
    fetchCategories();
  }, []);

  const columns = getAccountSubCategoriesColumns(categories);

  return (
    <Box m="2px">
      <DynamicTable
        title="Account Subcategories"
        subtitle="Create, view or edit account subcategories"
        columns={columns}
        FormComponent={AccountCategoryForm}
        query={allAccountSubCategories}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default AccountSubcategoriesTable;
